import { Add } from '@carbon/icons-react';
import { Button, Tooltip } from '@routable/gross-ds';
import React from 'react';
import { AddContactButtonTooltipContent } from 'complexComponents/AddContactButtonTooltipContent';
export const AddContactButtonTarget = ({ disabled, children = 'Contact', onClick, partnership, }) => (React.createElement(Tooltip, { "data-testid": "add-contact-tooltip", tooltip: disabled && React.createElement(AddContactButtonTooltipContent, { partnership: partnership }), variant: "light" },
    React.createElement(Button, { "data-testid": "add-contact-button", disabled: disabled, onPress: onClick, variant: "outline" },
        React.createElement(Add, { size: 14 }),
        children)));
